import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { delay, put, takeLatest } from 'redux-saga/effects';
import { NotificationReduxAction } from './notification';

export const showNotification = createAction<NotificationReduxAction>('notification/SHOW');
export const openNotification = createAction<NotificationReduxAction>('notification/OPEN');
export const hideNotification = createAction('notification/HIDE');

function* sagaShowNotificationFor2s(action: PayloadAction<NotificationReduxAction>) {
  yield put(action.payload);
  yield delay(2000);
  yield put({ type: 'CLEAR_NOTIFICATION' });
}

function* openNotificationSaga(action: PayloadAction<NotificationReduxAction>) {
  yield put(action.payload);
}

function* hideNotificationSaga() {
  yield put({ type: 'CLEAR_NOTIFICATION' });
}

function* notificationSaga() {
  yield takeLatest(showNotification, sagaShowNotificationFor2s);
  yield takeLatest(openNotification, openNotificationSaga);
  yield takeLatest(hideNotification, hideNotificationSaga);
}

export default notificationSaga;
